/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'batches': {
    width: 200,
    height: 200,
    viewBox: '0 0 1024 1024',
    data: '<defs/><path pid="0" d="M934.14 580.206H784.248V430.04c0-14.993-12.218-27.191-27.281-27.191-15.152 0-27.28 12.31-27.28 27.508v149.85H579.81c-15.219 0-27.484 12.219-27.484 27.304 0 15.174 12.174 27.284 27.191 27.284h150.166v149.869c0 15.243 12.219 27.485 27.28 27.485 15.2 0 27.282-12.175 27.282-27.17V634.793h150.211c14.972 0 27.147-12.222 27.147-27.284.001-15.173-12.286-27.304-27.462-27.304zM78.934 252.775h634.197c8.976 0 16.552-9.155 16.552-20.452 0-11.386-7.53-20.472-16.82-20.472H79.226c-9.335 0-16.83 9.152-16.83 20.472-.001 11.363 7.405 20.452 16.537 20.452zM79.217 525.642h455.702c9.243 0 16.822-9.154 16.822-20.475 0-11.362-7.53-20.45-16.843-20.45H79.238c-9.358 0-16.842 9.154-16.842 20.45 0 11.387 7.53 20.475 16.82 20.475zM585.064 757.584H79.126c-9.109 0-16.73 9.156-16.73 20.452 0 11.386 7.463 20.472 16.661 20.472H585.11c9.2 0 16.685-9.153 16.685-20.472 0-11.364-7.486-20.452-16.731-20.452z"/>'
  }
})
